const key = (parentUserId: number) => `selectedChild:${parentUserId}`;

/** The student whose details a login last picked (itself or a sibling) — kept per login. */
export function getSelectedChildId(parentUserId: number): number | null {
  try {
    const raw = localStorage.getItem(key(parentUserId));
    return raw ? Number(raw) : null;
  } catch {
    return null;
  }
}

export function setSelectedChildId(parentUserId: number, childId: number) {
  try {
    localStorage.setItem(key(parentUserId), String(childId));
  } catch {
    // Storage blocked: the selection just won't survive a reload.
  }
}

/** Read by the API client to attach X-Student-Id — the child the server should act as. Null for non-student accounts. */
export function currentActingChildId(): number | null {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    if (user?.role?.scope !== "STUDENT") return null;
    return getSelectedChildId(user.id);
  } catch {
    return null;
  }
}
